<template>
<validation-observer ref="simpleRules">
<b-overlay id="overlay-background"
        :show="show"
        :variant="variant"
        :opacity="opacity"
        :blur="blur"
        rounded="sm">
    <b-form>
        <b-row>
            <b-col md="6">
                <b-card-actions action-collapse title="Selected Users">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="text-muted small">
                            {{ users_selected.length ? users_selected.length + ' user' + (users_selected.length === 1 ? '' : 's') + ' selected' : 'No users selected' }}
                        </span>
                        <b-button variant="primary" size="sm" @click="openUserModal">
                            <feather-icon icon="PlusIcon" class="mr-50" />
                            Add Users
                        </b-button>
                    </div>

                    <div v-if="!users_selected.length" class="empty-state">
                        <feather-icon icon="UsersIcon" size="36" class="text-muted mb-1" />
                        <p class="text-muted mb-0">No users added yet. Click "Add Users" to search and select.</p>
                    </div>

                    <div v-else class="table-responsive">
                        <table class="table b-table table-striped table-hover mb-0">
                            <thead>
                                <tr>
                                    <th style="width:40px"></th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in users_selected" :key="item.id">
                                    <td>
                                        <feather-icon icon="Trash2Icon" class="text-danger cursor-pointer" @click="remove_user(item.id)" />
                                    </td>
                                    <td>{{ item.firstname }} {{ item.lastname }}</td>
                                    <td>
                                        <a v-if="item.email" :href="'mailto:'+item.email" class="small text-muted">{{ item.email }}</a>
                                    </td>
                                    <td>
                                        <a v-if="item.phone" :href="'tel:'+item.phone" class="small text-muted">{{ item.phone }}</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-card-actions>
            </b-col>
            <b-col md="6">
                <b-card-actions action-collapse title="Enquiry Requirement">
                    <b-row>
                        <b-col md="12">
                            <label>Title</label>
                            <b-form-group>
                            <b-form-input
                                id="title"
                                v-model="input.title"
                                placeholder="Title"
                              
                              
                            />
                            </b-form-group>
                            
                        </b-col>
                        <b-col md="12">
                            <label>Description</label>
                            <b-form-group>
                            <b-form-textarea
                                id="description"
                                v-model="input.description"
                                placeholder="Description"
                                rows="3"
                              
                            />
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <label>Looking For</label>
                            <b-form-group>
                            
                                <v-select
                                    v-model="input.looking"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="title"
                                  
                                    :options="option_looking"
                                />
                            
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <label>For</label>
                            <b-form-group>
                            
                                <v-select
                                    v-model="input.fors"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="title"
                                  
                                    :options="option_fors"
                                />
                            
                            </b-form-group>
                        </b-col>
                         <b-col md="6">
                            <label>Source</label>
                            <b-form-group>
                            
                                <v-select
                                    v-model="input.enquiry_source"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="title"
                                  
                                    :options="option_sources"
                                />
                            
                            </b-form-group>
                        </b-col>
                         <b-col md="3">
                            <label>Bedroom</label>
                            <b-form-group>
                            <b-form-spinbutton
                                v-model="input.bedroom"
                              
                                size="md"
                                class="ml-0"
                                inline
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <label>Bathroom</label>
                            <b-form-group>
                            <b-form-spinbutton
                                v-model="input.bathroom"
                              
                                size="md"
                                class="ml-0"
                                inline
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <label>Min - Buy Budget</label>
                            <b-form-group>
                                <b-form-input
                                        v-model="input.buy_min"
                                       
                                        placeholder="0"
                                    />
                            </b-form-group>
                        </b-col>
                         <b-col md="6">
                            <label>Max - Buy Budget</label>
                            <b-form-group>
                                <b-form-input
                                        v-model="input.buy_max"
                                       
                                        placeholder="0"
                                    />
                            </b-form-group>
                        </b-col>
                         <b-col md="6">
                            <label>MIN - Rental Budget</label>
                            <b-form-group>
                                <b-form-input
                                        v-model="input.rent_min"
                                       
                                        placeholder="0"
                                    />
                            </b-form-group>
                        </b-col>
                         <b-col md="6">
                            <label>MAX - Rental Budget</label>
                            <b-form-group>
                                <b-form-input
                                        v-model="input.rent_max"
                                       
                                        placeholder="0"
                                    />
                            </b-form-group>
                        </b-col>
                         <b-col md="6">
                            <b-form-group>
                                <label>Zone</label>
                                <v-select
                                v-model="input.zone_id"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="name"
                                :reduce="(option) => option.id"
                                :options="zone.map((g) => ({
                                    name: g.name[currentLocale],
                                    id: g.id
                                }))"
                        />
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <label>BTS Interest</label>
                                <v-select
                                v-model="input.bts_id"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="name"
                                :options="bts"
                        />
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <label>MRT Interest</label>
                                <v-select
                                v-model="input.mrt_id"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="name"
                                :options="mrt"
                        />
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <label>Airport Link Interest</label>
                                <v-select
                                v-model="input.airport_id"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="name"
                                :options="airport"
                        />
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
          
                            <b-form-group>
                            <label>Property Pin Interest</label>
                            <validation-provider
                            #default="{ errors }"
                            rules="min:0"
                            name="place_id"
                            >
                                <vue-autosuggest
                                ref="autocomplete"
                                name="place_id"
                                v-model="place_id"
                                :suggestions="suggestions"
                                :input-props="inputProps"
                                :section-configs="sectionConfigs"
                                :render-suggestion="renderSuggestion"
                                :get-suggestion-value="getSuggestionValue"
                                @input="fetchResults"
                                />    
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-form-group label="CC Email">
                                <b-input-group>
                                    <b-form-input
                                        v-model="newEmail"
                                        type="email"
                                        placeholder="Enter email"
                                        @keyup.enter="addEmail"
                                    />
                                    <b-input-group-append>
                                        <b-button variant="primary" @click="addEmail">Add</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>

                            <div>
                                <ul class="list-unstyled">
                                <li
                                    v-for="(email, index) in input.ccEmails"
                                    :key="index"
                                    class="d-flex align-items-center justify-content-between px-3 py-2"
                                >
                                    <span>{{ email.email? email.email: email }}</span>
                                    <b-button variant="danger" size="sm" @click="removeEmail(index)" v-if="email.is_default? !email.is_default: 1">
                                        ✕
                                    </b-button>
                                </li>
                                </ul>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Email Subscriptions</label>
                                <validation-provider
                                    #default="{ errors }"
                                    name="is_subscript"
                                >
                                    <b-form-checkbox
                                        checked="true"
                                        class="custom-control-primary"
                                        v-model="input.is_subscript"
                                        switch
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group> 
                        </b-col>
                         <b-col cols="12">
                            <b-button
                                variant="primary"
                                type="submit"
                                @click.prevent="validationForm"
                            >
                                Submit
                            </b-button>
                        </b-col>
                    </b-row> 
                </b-card-actions>
            </b-col>
            <b-col md="12">
              <b-card-actions action-collapse title="Selected Properties">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <span class="text-muted small">
                    {{ properties_selected.length ? properties_selected.length + ' propert' + (properties_selected.length === 1 ? 'y' : 'ies') + ' selected' : 'No properties selected' }}
                  </span>
                  <b-button variant="primary" size="sm" @click="openPropertyModal">
                    <feather-icon icon="PlusIcon" class="mr-50" />
                    Add Properties
                  </b-button>
                </div>

                <div v-if="!properties_selected.length" class="empty-state">
                  <feather-icon icon="InboxIcon" size="36" class="text-muted mb-1" />
                  <p class="text-muted mb-0">No properties added yet. Click "Add Properties" to browse and select.</p>
                </div>

                <div v-else class="table-responsive">
                  <table class="table b-table table-striped table-hover">
                    <thead>
                      <tr>
                        <th style="width:40px"></th>
                        <th>Image</th>
                        <th>Property</th>
                        <th>Owner</th>
                        <th>Unit / Floor</th>
                        <th>Type</th>
                        <th>BD</th>
                        <th>SQM</th>
                        <th>Rent (THB)</th>
                        <th>Sale (THB)</th>
                        <th>Exp/Avail</th>
                        <th>Furniture</th>
                        <th>BTS</th>
                        <th>MRT</th>
                        <th>Zone</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in properties_selected" :key="item.id">
                        <td>
                          <feather-icon icon="Trash2Icon" class="text-danger cursor-pointer" @click="remove_property(item.id)" />
                        </td>
                        <td>
                          <b-img class="img_property" v-if="item.property_images[0]" :src="item.property_images[0].fullfilepath" />
                          <b-img class="img_property" v-else :src="'https://digitalnation.sgp1.cdn.digitaloceanspaces.com/findbangkokroom/storage/1698858264911-picture.png'" />
                        </td>
                        <td>
                          <div class="list-property">
                            <router-link :to="{ name: 'property-edit', params: { id: item.id } }">{{ item.property_code }}</router-link>
                            <b-badge v-if="item.action_id == 1" variant="light-secondary">{{ item.action_name }}</b-badge>
                            <b-badge v-if="item.action_id == 2" variant="light-info">{{ item.action_name }}</b-badge>
                            <b-badge v-if="item.action_id == 3" variant="light-success">{{ item.action_name }}</b-badge>
                            <b-badge v-if="item.action_id == 4" variant="light-warning">{{ item.action_name }}</b-badge>
                            <b-badge v-if="item.status_id == 1" variant="light-success">{{ item.status_code }}</b-badge>
                            <b-badge v-else variant="light-secondary">{{ item.status_code }}</b-badge>
                            <div class="text-muted small mt-25">{{ item.place_name && item.place_name[currentLocale] ? item.place_name[currentLocale] : (item.place_title || '') }}</div>
                          </div>
                        </td>
                        <td>
                          <router-link :to="{ name: 'clients-edit', params: { id: item.owner_id } }" target="_blank">
                            {{ item.owner_firstname }} {{ item.owner_lastname }}
                          </router-link>
                          <div><a :href="'mailto:'+item.owner_email" class="small text-muted">{{ item.owner_email }}</a></div>
                          <div><a :href="'tel:'+item.owner_phone" class="small text-muted">{{ item.owner_phone }}</a></div>
                        </td>
                        <td>{{ item.units }} {{ item.address_no }}<br /><small class="text-muted">Fl {{ item.floors }}</small></td>
                        <td>{{ item.type_name }}</td>
                        <td>{{ item.bedroom }}</td>
                        <td>{{ item.sqm }}</td>
                        <td>{{ item.rent_price | getcomma }}</td>
                        <td>{{ item.sale_price | getcomma }}</td>
                        <td>{{ item.exp }}</td>
                        <td>{{ item.furniture_name }}</td>
                        <td>{{ item.bts_name }}</td>
                        <td>{{ item.mrt_name }}</td>
                        <td>{{ item.zone_name }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-card-actions>
            </b-col>
        </b-row>

        <!-- Property Picker Modal -->
        <b-modal v-model="showPropertyModal" title="Add Properties" size="xl" no-close-on-backdrop body-class="p-0">
          <div class="property-modal-split">
            <div v-if="showMobileFilters" class="mobile-filter-backdrop" @click="showMobileFilters = false" />

            <div class="property-modal-sidebar" :class="{ 'mobile-open': showMobileFilters }">
              <div class="d-flex align-items-center justify-content-between mb-1">
                <div class="section-label">Filters</div>
                <feather-icon icon="XIcon" size="16" class="cursor-pointer d-md-none text-muted" @click="showMobileFilters = false" />
              </div>
              <b-form-group label="Project Name" label-class="filter-field-label">
                <b-form-input v-model="modalPlaceKeyword" placeholder="project name" size="sm" />
              </b-form-group>
              <b-form-group label="Property Code" label-class="filter-field-label">
                <b-form-input v-model="propertyfilter" placeholder="e.g. P001" size="sm" />
              </b-form-group>
              <b-form-group label="Owner Name" label-class="filter-field-label">
                <b-form-input v-model="ownerfilter" placeholder="First name, last name, phone or email" size="sm" />
              </b-form-group>
              <b-form-group label="Building" label-class="filter-field-label">
                <b-form-input v-model="building" placeholder="Building name" size="sm" />
              </b-form-group>
              <b-form-group label="Unit" label-class="filter-field-label">
                <b-form-input v-model="unit" placeholder="Unit no." size="sm" />
              </b-form-group>
              <b-form-group label="Type" label-class="filter-field-label">
                <b-form-input v-model="types" placeholder="e.g. Condo, House" size="sm" />
              </b-form-group>
              <b-form-group label="Floor" label-class="filter-field-label">
                <b-form-input v-model="floor" placeholder="Floor no." size="sm" />
              </b-form-group>
              <b-form-group label="Bedroom" label-class="filter-field-label">
                <b-form-input v-model="bedroom" placeholder="No. of bedrooms" size="sm" />
              </b-form-group>
              <b-form-group label="SQM" label-class="filter-field-label">
                <b-form-input :value="sqm_min_display" @input="v => handleNumericInput('sqm_min', 'sqm_min_display', v)" placeholder="Min" size="sm" class="mb-50" />
                <b-form-input :value="sqm_max_display" @input="v => handleNumericInput('sqm_max', 'sqm_max_display', v)" placeholder="Max" size="sm" />
              </b-form-group>
              <b-form-group label="Rent Price (THB)" label-class="filter-field-label">
                <b-form-input :value="price_rent_min_display" @input="v => handleNumericInput('price_rent_min', 'price_rent_min_display', v)" placeholder="Min" size="sm" class="mb-50" />
                <b-form-input :value="price_rent_max_display" @input="v => handleNumericInput('price_rent_max', 'price_rent_max_display', v)" placeholder="Max" size="sm" />
              </b-form-group>
              <b-form-group label="Sale Price (THB)" label-class="filter-field-label">
                <b-form-input :value="price_sale_min_display" @input="v => handleNumericInput('price_sale_min', 'price_sale_min_display', v)" placeholder="Min" size="sm" class="mb-50" />
                <b-form-input :value="price_sale_max_display" @input="v => handleNumericInput('price_sale_max', 'price_sale_max_display', v)" placeholder="Max" size="sm" />
              </b-form-group>
              <b-form-checkbox v-model="statusId" value="1" @input="change_status" class="custom-control-primary mb-2">
                Available Only
              </b-form-checkbox>
              <b-button variant="outline-secondary" block size="sm" @click="resetModalFilters">
                <feather-icon icon="RefreshCwIcon" size="13" class="mr-50" />
                Reset Filters
              </b-button>
            </div>

            <div class="property-modal-results">
              <div class="mobile-filter-bar d-flex d-md-none align-items-center justify-content-between px-1 py-75">
                <b-button variant="outline-secondary" size="sm" @click="showMobileFilters = true">
                  <feather-icon icon="SlidersIcon" size="14" class="mr-50" />
                  Filters
                  <b-badge v-if="activeFilterCount > 0" variant="primary" pill class="ml-25">{{ activeFilterCount }}</b-badge>
                </b-button>
                <small class="text-muted">{{ totalpRows }} result{{ totalpRows !== 1 ? 's' : '' }}</small>
              </div>
              <b-table
                striped hover responsive no-local-sorting
                :items="properties"
                :fields="fields_properties_modal"
                :sort-by.sync="modalSortBy"
                :sort-desc.sync="modalSortDesc"
                show-empty
                empty-text="No matching records found"
                class="mb-0"
                @sort-changed="onModalSortChanged"
              >
                <template #cell(id)="data">
                  <b-form-checkbox v-model="modalSelected" :value="data.item" :checked="modalSelected.some(s => s.id === data.item.id)" />
                </template>
                <template #cell(units)="data">
                  {{ data.item.units }} {{ data.item.address_no }}
                </template>
                <template #cell(property)="data">
                  <div class="list-property">
                    <router-link :to="{ name: 'property-edit', params: { id: data.item.id } }" target="_blank">{{ data.item.property_code }}</router-link>
                    <b-badge v-if="data.item.action_id == 1" variant="light-secondary">{{ data.item.action_name }}</b-badge>
                    <b-badge v-if="data.item.action_id == 2" variant="light-info">{{ data.item.action_name }}</b-badge>
                    <b-badge v-if="data.item.action_id == 3" variant="light-success">{{ data.item.action_name }}</b-badge>
                    <b-badge v-if="data.item.action_id == 4" variant="light-warning">{{ data.item.action_name }}</b-badge>
                    <b-badge v-if="data.item.status_id == 1" variant="light-success">{{ data.item.status_code }}</b-badge>
                    <b-badge v-else variant="light-secondary">{{ data.item.status_code }}</b-badge>
                    <div class="text-muted small">{{ data.item.place_name && data.item.place_name[currentLocale] ? data.item.place_name[currentLocale] : (data.item.place_title || '') }}</div>
                  </div>
                </template>
                <template #cell(image)="data">
                  <b-button variant="flat-primary" class="pb0" :to="{ name: 'property-upload', params: { id: data.item.id } }" target="_blank">
                    <b-img class="img_property" v-if="data.item.property_images && data.item.property_images[0]" :src="data.item.property_images[0].fullfilepath" />
                    <b-img class="img_property" v-else :src="'https://digitalnation.sgp1.cdn.digitaloceanspaces.com/findbangkokroom/storage/1698858264911-picture.png'" />
                  </b-button>
                </template>
                <template #cell(owner)="data">
                  <div>{{ data.item.owner_firstname }} {{ data.item.owner_lastname }}</div>
                  <a :href="'mailto:'+data.item.owner_email" class="small text-muted">{{ data.item.owner_email }}</a>
                </template>
                <template #cell(price_rent)="data">{{ data.item.rent_price | getcomma }}</template>
                <template #cell(price_sale)="data">{{ data.item.sale_price | getcomma }}</template>
              </b-table>
              <b-pagination
                v-if="totalpRows > 0"
                v-model="currentpPage"
                :total-rows="totalpRows"
                :per-page="perPagep"
                align="center"
                size="sm"
                class="my-1 px-1"
              />
            </div>
          </div>

          <template #modal-footer>
            <div class="modal-footer-inner w-100">
              <span class="text-muted small modal-footer-count">
                <template v-if="modalSelected.length">
                  <b-badge variant="primary" pill>{{ modalSelected.length }}</b-badge>
                  propert{{ modalSelected.length === 1 ? 'y' : 'ies' }} selected
                </template>
                <template v-else>Select properties from the list</template>
              </span>
              <div class="modal-footer-actions">
                <b-button variant="outline-secondary" @click="showPropertyModal = false">Cancel</b-button>
                <b-button variant="primary" :disabled="!modalSelected.length" @click="applyModalSelection">
                  Add Selected
                </b-button>
              </div>
            </div>
          </template>
        </b-modal>

        <!-- User Picker Modal -->
        <b-modal v-model="showUserModal" title="Add Users" size="lg" no-close-on-backdrop body-class="p-0">
          <div class="p-1">
            <b-form-input
              v-model="filter_user"
              type="search"
              placeholder="Search by name, email or phone"
              class="mb-1"
            />
            <b-table
              striped hover responsive
              :items="users"
              :fields="fields"
              show-empty
              empty-text="No matching records found"
              class="mb-0"
            >
              <template #cell(id)="data">
                <b-form-checkbox v-model="modalSelectedUsers" :value="data.item" :checked="modalSelectedUsers.some(s => s.id === data.item.id)" />
              </template>
              <template #cell(name)="data">
                {{ data.item.firstname }} {{ data.item.lastname }}
              </template>
            </b-table>
            <b-pagination
              v-if="totalRows > 0"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-1 px-1"
            />
          </div>

          <template #modal-footer>
            <div class="modal-footer-inner w-100">
              <span class="text-muted small modal-footer-count">
                <template v-if="modalSelectedUsers.length">
                  <b-badge variant="primary" pill>{{ modalSelectedUsers.length }}</b-badge>
                  user{{ modalSelectedUsers.length === 1 ? '' : 's' }} selected
                </template>
                <template v-else>Select users from the list</template>
              </span>
              <div class="modal-footer-actions">
                <b-button variant="outline-secondary" @click="showUserModal = false">Cancel</b-button>
                <b-button variant="primary" :disabled="!modalSelectedUsers.length" @click="applyUserModalSelection">
                  Add Selected
                </b-button>
              </div>
            </div>
          </template>
        </b-modal>
    </b-form>
</b-overlay>

</validation-observer>

</template>
<script>
import { VueAutosuggest } from 'vue-autosuggest'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
    BOverlay,BFormInput, BFormGroup, BForm, BRow, BCol, BButton,BFormTextarea,BFormRating,BFormCheckbox,BFormCheckboxGroup,BFormSpinbutton,BTable,BPagination
} from 'bootstrap-vue'
import {
  BCard, BMedia, BAvatar, BCardText, BMediaAside, BMediaBody, BImg, BFormFile, BLink, BBadge,
  BInputGroup, BInputGroupAppend, BModal,
} from 'bootstrap-vue'
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@validations'
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import axios from '@axios'


//popup
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref } from '@vue/composition-api'
import { useClipboard } from '@vueuse/core'

import router from '@/router'
export default {
    components: {
        BOverlay,
        BCardActions,
        VueAutosuggest,
        ValidationProvider,
        ValidationObserver,
        BFormInput,
        BFormGroup,
        BForm,
        BRow,
        BCol,
        BButton,
        BFormTextarea,
        BFormRating,
        BFormSpinbutton,
        vSelect,
        BFormCheckbox,
        BFormCheckboxGroup,
        BCard, BMedia, BAvatar, BCardText, BMediaAside, BMediaBody, BImg, BFormFile, BLink,
        BTable, BPagination,
        BBadge, BInputGroup, BInputGroupAppend, BModal,
  },
  
  data(){
      return{
        variant: 'light',
        opacity: 0.85,
        blur: '2px',
        show: false,
        id:router.currentRoute.params.id,
        user_id:router.currentRoute.params.clientId,
        checkout:router.currentRoute.params.checkout,
          unit:null,
          floor:null,
          types:null,
          building:null,
          bedroom:null,
          sqm_min:null,
          sqm_max:null,
          sqm_min_display:'',
          sqm_max_display:'',
          price_rent_min:null,
          price_rent_max:null,
          price_rent_min_display:'',
          price_rent_max_display:'',
          price_sale_min:null,
          price_sale_max:null,
          price_sale_min_display:'',
          price_sale_max_display:'',
          price_min:null,
          price_max:null,
          action_id:null,
          modalPlaceKeyword:null,
          showPropertyModal:false,
          showMobileFilters:false,
          modalSelected:[],
          showUserModal:false,
          modalSelectedUsers:[],
          modalSortBy:null,
          modalSortDesc:false,
          propertyfilter:null,
          ownerfilter:null,
          input:{
              title:null,
              description:null,
              looking:null,
              fors:null,
              enquiry_source:null,
              bedroom:0,
              bathroom:1,
              buy_min:null,
              buy_max:null,
              rent_min:null,
              rent_max:null,
              zone_id:null,
              bts_id:null,
              mrt_id:null,
              airport_id:null,
              place_id:null,
              is_subscript: true,
              ccEmails: [],
          },
          place_id:'',
          zone:[],
          bts:[],
          mrt:[],
          airport:[],
          properties:[],
            userData: JSON.parse(localStorage.getItem('userData')),
          users:[],
          users_selected:[],
          properties_selected:[],
          filter_user:null,
          option_looking: 
            [
            { id: "Sale & Rent", title: 'Sale & Rent' }, 
            { id: "Sale", title: 'Sale' }, 
            { id: "Rent", title: 'Rent' }, 
          
         ],
         option_fors: 
        [
            { id: "Own Stay", title: 'Own Stay' }, 
            { id: "Investment", title: 'Investment' }, 
           
          
         ],
         option_sources:[
            { id: "Co-Agent", title: 'Co-Agent' }, 
            { id: "Walk-in", title: 'Walk-in' }, 
            { id: "Call in", title: 'Call in' }, 
            { id: "At Site", title: 'At Site' }, 
            { id: "Website", title: 'Website' }, 
            { id: "Our Website", title: 'Our Website' }, 
            { id: "Refer", title: 'Refer' }, 
            { id: "Other", title: 'Other' }, 

         ],
         inputProps: {
            id: 'autosuggest__input_ajax',
            placeholder: 'Property Pin',
            class: 'form-control',
            name: 'pin_id',
        },
        suggestions: [],
        sectionConfigs: {
            place: {
                limit: 6,
                label: 'Place',
                onSelected: selected => {
                    this.input.place_id = selected.item.id;
                               console.log('place_id',selected.item);
                        this.properties = [];
                    this.currentPage = 1
                   this.searchQuery = selected.item.name;
                    this.get_properties();
                                
                    
                },
            },
        },
        searchQuery:null,
        statusId:'',
        perPage: 5,
        perPagep: 15,
        offset:0,
        pageOptions: [3, 5, 10],
        totalRows: 0,
        totalRowsSelected: 1,
        currentPage: 1,
        currentpsPage:1,
        currentpPage:1,
        currentPageSelected: 1,
        currentpPageSelected:1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        totalpRows:0,
         totalpsRows:0,
        bts_id:'',
        zone_id:'',
        mrt_id:'',
        airport_id:'',
        fields_properties:[
            {
                key: 'id', label: '',
            },
            {
                key: 'image', label: 'Image', tdClass:'width-300 p-0',
            },
            {
                key: 'property', label: 'Property Code',
            },
             {
                key: 'owner', label: 'Owner',
            },
            {
                key: 'units', label: 'units',
            },
            {
                key: 'floors', label: 'Floor',
            },
            {
                key: 'type_name', label: 'Type',
            },
            {
                key: 'buildiing', label: 'Building',
            },
            {
                key: 'bedroom', label: 'Bd',
            },
            {
                key: 'sqm', label: 'Sqm',
            },
            {
                key: 'price_rent', label: 'Rent',
            },
            {
                key: 'price_sale', label: 'Sale',
            },
            {
                key: 'exp', label: 'Exp/Avail Date  ',
            },
            {
                key: 'rating', label: 'Rating',
            },
            {
                key: 'furniture_name', label: 'Furniture',
            },
            {
                key: 'bts_name', label: 'BTS',
            },
            {
                key: 'mrt_name', label: 'MRT',
            },
            {
                key: 'zone_name', label: 'Zone',
            },
        ],
        fields_properties_modal: [
          { key: 'id', label: '' },
          { key: 'image', label: 'Image', tdClass: 'width-300 p-0' },
          { key: 'property', label: 'Property Code' },
          { key: 'owner', label: 'Owner' },
          { key: 'units', label: 'Unit No.' },
          { key: 'floors', label: 'Floor', sortable: true },
          { key: 'type_name', label: 'Type' },
          { key: 'buildiing', label: 'Building' },
          { key: 'bedroom', label: 'Bd', sortable: true },
          { key: 'sqm', label: 'Sqm', sortable: true },
          { key: 'price_rent', label: 'Rent', sortable: true },
          { key: 'price_sale', label: 'Sale', sortable: true },
          { key: 'exp', label: 'Exp/Avail' },
          { key: 'furniture_name', label: 'Furniture' },
          { key: 'bts_name', label: 'BTS' },
          { key: 'mrt_name', label: 'MRT' },
          { key: 'zone_name', label: 'Zone' },
        ],
        fields: [
            {
                key: 'id', label: '',
            },
            {
                key: 'name', label: 'ชื่อ-นามสกุล',
            },
             {
                key: 'email', label: 'อีเมล',
            },
             {
                key: 'phone', label: 'เบอร์โทรศัพท์',
            },
       
      
        ],
        newEmail: '',
        defaultEmails: [],
      }
  },
  directives: {
    Ripple,
  },
  created(){
      this.getZone();
      this.getBts();
      this.getMrt();
      this.getAirport();
      this.get_properties();
      this.getDefaultEmail()

    if(this.id != undefined){
         setTimeout(() => {
          this.getData();
        }, 500);
    }
    if(this.user_id != undefined){
        this.get_user();
    }

    
    if(this.checkout != undefined){
        //this.get_propertyselectbyCart();
         setTimeout(() => {
          this.get_propertyselectbyCart();
        }, 500);

    }
      
  },
  watch:{
   /* 'input.bedroom':function(value){
    
         this.properties = [];
         this.currentPage = 1
        this.bedroom=value;
        this.get_properties();

    },
    'input.bts_id':function(value){
        console.log('bts_id', value);
         this.properties = [];
         this.currentPage = 1
         this.bts_id= '';
         if(value){
              this.bts_id=value.id;
         }
       
        this.get_properties();

    },
    'input.zone_id':function(value){
        console.log('bedroom', value);
         this.properties = [];
         this.currentPage = 1
         this.zone_id= '';
         if(value){
              this.zone_id=value.id;
         }
        
        this.get_properties();

    },
     'input.airport_id':function(value){
        console.log('bedroom', value);
         this.properties = [];
         this.currentPage = 1
         this.airport_id= '';
         if(value){
              this.airport_id=value.id;
         }
        
        this.get_properties();

    },
    'input.mrt_id':function(value){
        console.log('bedroom', value);
         this.properties = [];
         this.currentPage = 1
          this.mrt_id= '';
         if(value){
              this.mrt_id=value.id;
         }
        
        this.get_properties();

    },
    'input.bathroom':function(value){
        console.log('bedroom', value);
         this.properties = [];
         this.currentPage = 1
        this.bathroom=value;
        this.get_properties();

    },*/
   /* 'input.rent_min':function(value){
        this.price_min = value;
        if(!this.input.rent_min && !this.input.rent_max){
             this.action_id = '';
        }else{
             this.action_id = '2,4';
        }
         this.currentPage = 1
         this.get_properties();
        

    },
    'input.rent_max':function(value){
        this.price_max = value;
      if(!this.input.rent_min && !this.input.rent_max){
             this.action_id = '';
        }else{
             this.action_id = '2,4';
        }
         this.currentPage = 1
         this.get_properties();
        

    },
    'input.buy_min':function(value){
        this.price_min = value;
         if(!this.input.buy_min && !this.input.buy_max){
             this.action_id = '';
        }else{
             this.action_id = '1,3';
        }
         this.currentPage = 1
         this.get_properties();
        

    },
    'input.buy_max':function(value){
        this.price_max = value;
        if(!this.input.buy_min && !this.input.buy_max){
             this.action_id = '';
        }else{
             this.action_id = '1,3';
        }
         this.currentPage = 1
         this.get_properties();
        

    },*/
    floor(value){
        console.log('floor',value);
        this.floor = value;
         this.currentPage = 1
          this.get_properties();

    },
  
    building(value){
         this.building = value;
         this.currentPage = 1
          this.get_properties();

    },
    propertyfilter(value){
        this.properties = [];
         this.currentPage = 1
         this.propertyfilter = value;
        this.get_properties();
      },
      ownerfilter(value){
         this.properties = [];
         this.currentPage = 1
         this.ownerfilter = value;
        this.get_properties();
      },
      bedroom(value){
        this.properties = [];
         this.currentPage = 1
         this.bedroom = value;
        this.get_properties();
      },
      unit(value){
        this.properties = [];
        this.currentPage = 1;
        this.unit = value;
        this.get_properties();
      },
      types(value){
        this.properties = [];
        this.currentPage = 1;
        this.types = value;
        clearTimeout(this._typeDebounce);
        this._typeDebounce = setTimeout(() => { this.get_properties(); }, 400);
      },
      sqm_min(){ this.currentPage = 1; this.get_properties(); },
      sqm_max(){ this.currentPage = 1; this.get_properties(); },
      price_rent_min(){ this.currentPage = 1; this.get_properties(); },
      price_rent_max(){ this.currentPage = 1; this.get_properties(); },
      price_sale_min(){ this.currentPage = 1; this.get_properties(); },
      price_sale_max(){ this.currentPage = 1; this.get_properties(); },
      modalPlaceKeyword(){
        this.properties = [];
        this.currentPage = 1;
        clearTimeout(this._placeDebounce);
        this._placeDebounce = setTimeout(() => { this.get_properties(); }, 400);
      },
      
      filter_user(value){
           this.users = [];
          this.filter_user = value;
          this.currentPage = 1
          this.get_users();
      },
      currentPage(value){
          this.users = [];
        this.currentPage = value;
         this.get_users();
      },
     
      
      currentpPage(value){
           this.properties = [];
        this.currentpPage = value;
         this.get_properties();
      }

  },
  filters: {
    getcomma: function(text){
      if(!text){
        return ''

      }
			 var nStr = text;
			nStr += '';
			var x = nStr.split('.');
			var x1 = x[0];
			var x2 = x.length > 1 ? '.' + x[1] : '';
			var rgx = /(\d+)(\d{3})/;
			while (rgx.test(x1)) {
				x1 = x1.replace(rgx, '$1' + ',' + '$2');
			}
			return x1 ;
		},
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    activeFilterCount() {
      return [
        this.propertyfilter, this.ownerfilter, this.building,
        this.unit, this.types, this.floor, this.bedroom,
        this.sqm_min, this.sqm_max,
        this.price_rent_min, this.price_rent_max,
        this.price_sale_min, this.price_sale_max,
        this.statusId === '1' ? '1' : null,
        this.modalPlaceKeyword,
      ].filter(v => v !== null && v !== '' && v !== undefined).length;
    },
  },
  methods: {
    change_status(){
        this.properties = []
         this.currentPage = 1
        this.get_properties();

    },
    async getData(){
         // console.log('userdata',this.userData);
         
           var enquiry = await axios.get('enquiry/v1/get/'+this.id);
           var enq = enquiry.data.data;

           this.input = enq;
           this.place_id = this.input.place_name;
           if(this.input.place_name){
               this.searchQuery = this.input.place_name;
                this.properties = [];
                this.currentPage = 1
              
                this.get_properties();

           }
         
           if(enq.bts_id){
                var bts = this.bts.filter(j => j.id == enq.bts_id);
                if(bts){
                  this.input.bts_id =bts[0];
                }
           }
           if(enq.mrt_id){
                var mrt = this.mrt.filter(j => j.id == enq.mrt_id);
                if(mrt){
                  this.input.mrt_id =mrt[0];
                }
           }
           if(enq.airport_id){
                var airport = this.airport.filter(j => j.id == enq.airport_id);
                if(airport){
                  this.input.airport_id =airport[0];
                }
           }
           if(enq.zone_id){
                this.input.zone_id = enq.zone_id
           }
           if(enq.properties){
               const props = this.properties;
               let selected = [];
               enq.properties.forEach(item => {
                   selected.push(item.property_id*1);
                    
          
               });
               if(selected){
                   this.ps = selected;
                   this.get_propertyselect();
               }
               
              

           }
           //console.log('enquiry',enquiry);
          ///enquiry/v1/get/
      },
       async get_propertyselectbyCart(){
           let data = {
            perpage: 40,
            offset:0,
       
            bedroom:this.bedroom,
            unit:this.unit,
            sqm:this.sqm,
            statusId:null,
            price_sale:null,
            price_rent:null,
           userCart:this.userData.id
         }
         
         data = JSON.stringify(data);
        let pf = await axios.post('cache-master/v1/property-filter', data);
        console.log('data_selected',pf);
        if(pf.data){
             this.properties_selected = pf.data.data;
          
             this.totalpsRows = pf.data.total;
         }else{
             this.totalpsRows = 0;
         }
          
           // this.properties_selected = selected;
               //  this.totalpsRows = this.properties_selected.length;

      },
      async get_propertyselect(){
           let data = {
            perpage: 40,
            offset:0,
       
            bedroom:this.bedroom,
            unit:this.unit,
            sqm:this.sqm,
            statusId:null,
            price_sale:null,
            price_rent:null,
           enq_id:this.id
         }
         
         data = JSON.stringify(data);
        let pf = await axios.post('cache-master/v1/property-filter', data);
        console.log('data_selected',pf);
        if(pf.data){
             this.properties_selected = pf.data.data;
          
             this.totalpsRows = pf.data.total;
         }else{
             this.totalpsRows = 0;
         }
          
           // this.properties_selected = selected;
               //  this.totalpsRows = this.properties_selected.length;

      },
      add_property(item){
          let index =  this.properties_selected.findIndex(p => p.id === item.id);
          if(index <  0){
            this.properties_selected.push(item);
            this.totalpsRows = this.properties_selected.length;
          }

      },
      remove_user(id){
          
        this.users_selected = this.users_selected.filter(v => v.id  != id);
        /* this.users_selected= $.grep(this.users_selected, function(e){ 
                return e.id != id; 
            });*/
          this.totalRowsSelected = this.users_selected.length;
          
       

      },
      remove_property(id){
          this.properties_selected = this.properties_selected.filter(v => v.id  != id);
       
          this.totalpsRows = this.properties_selected.length;
      },
      async get_properties(){
          const offset = this.perPagep * (this.currentpPage - 1);
          let data = {
            perpage: this.perPagep,
            offset,
            keyword: this.searchQuery,
            place_keyword: this.modalPlaceKeyword || null,
            propertyfilter: this.propertyfilter,
            ownerfilter: this.ownerfilter,
            bedroom: this.bedroom,
            unit: this.unit,
            sqm_min: this.sqm_min,
            sqm_max: this.sqm_max,
            price_rent_min: this.price_rent_min,
            price_rent_max: this.price_rent_max,
            price_sale_min: this.price_sale_min,
            price_sale_max: this.price_sale_max,
            bts_id: this.bts_id,
            mrt_id: this.mrt_id,
            zone_id: this.zone_id,
            airport_id: this.airport_id,
            price_min: this.price_min,
            price_max: this.price_max,
            action_id: this.action_id,
            floors: this.floor,
            building: this.building,
            type_name: this.types,
            statusId: this.statusId === '1' ? this.statusId : null,
            sortBy: this.modalSortBy,
            sortDesc: this.modalSortDesc ? 'DESC' : 'ASC',
          };
          data = JSON.stringify(data);
          let properties = await axios.post('cache-master/v1/property-filter', data);
        if(properties.data){
             this.properties = properties.data.data;
          
             this.totalpRows = properties.data.total;
         }else{
             this.totalpRows = 0;
         }
        console.log('properties',properties);

      },
      async get_user(){
       var user = await axios.get('users/v1/detail/'+this.user_id);
       if(user.data.data){
         this.users_selected.push(user.data.data);
        
       }
        
        

      },
      async get_users(){
         
         const offset =  this.perPage*(this.currentPage-1);
         
         let data = {
            perpage: this.perPage,
            offset:offset,
            keyword:this.filter_user 
         }
         data = JSON.stringify(data);
         var users = await axios.post('/users/v1/lists', data);
         //console.log('filter',this.filter_user );
         if(users.data){
             this.users = users.data.data;
            console.log('users',this.users);
             this.totalRows = users.data.total;
         }else{
             this.totalRows = 0;
         }
         
        

      },
      getAirport(){
          axios.get('transit/v1/listtype/airport')
            .then(res => { 
            // console.log('res',res);
                this.airport = res.data.data; 
            })
      },
      getMrt(){
          axios.get('transit/v1/listtype/mrt')
            .then(res => { 
            // console.log('res',res);
                this.mrt = res.data.data; 
            })
      },
      getBts(){
          axios.get('transit/v1/listtype/bts')
            .then(res => { 
            // console.log('res',res);
                this.bts = res.data.data; 
            })
      },
      getZone(){
       let queryParams1 = {
            perpage: 1000,
            offset:0
        
        }
        let data1 = JSON.stringify(queryParams1)
        axios.post('zone/v1/lists',data1)
        .then(res => { 
            console.log('zone_res',res);
            this.zone = res.data.data; 
        })
      },
     
        fetchResults() {
        const { place_id } = this
        console.log('query',place_id);
        if(place_id){

        
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                var data = JSON.stringify({
                    "keyword": place_id
                    });
                const placePromise = axios.post('autocomplete/v1/place',data)
            
                

                Promise.all([placePromise]).then(values => {
                    this.suggestions = []
                     this.selected = null
                    console.log('values', values[0].data.data);
                    var data =  values[0].data.data;
                    this.suggestions.push({ name: 'place', data: data })
                
                // this.suggestions.push();
                }).catch(error=>{
                    console.log('error', error)
                })
            }, this.debounceMilliseconds)
        }else{
            this.suggestions = []
        }
        },
        
        filterResults(data, text, field) {
        return data.filter(item => {
            if (item[field].toLowerCase().indexOf(text.toLowerCase()) > -1) {
            return item[field]
            }
            return false
        }).sort()
        },
        renderSuggestion(suggestion) {
            console.log('suggestion',suggestion);
        
        return suggestion.item.name
        },
        getSuggestionValue(suggestion) {
        const { name, item } = suggestion
        console.log('suggestion',suggestion);
        
        return name === 'hotels' ? item.title : item.name
        },
        makeToast(variant = null,title,message) {
      this.$bvToast.toast(message, {
        title: title,
        variant,
        solid: true,
      })
    },
      doCopy(Pname,Pcode) {
      this.$copyText('https://findbangkokroom.com/condo/'+Pname.replace(/\s/g,'-')+'/'+Pcode).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Text copied',
            icon: 'BellIcon',
          },
        })
      }, e => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Can not copy!',
            icon: 'BellIcon',
          },
        })
      })
    },
     async  validationForm(event) {
         
          this.$refs.simpleRules.validate().then(success => {
            this.show = true;
               if (success) {
                   if(this.users_selected.length == 0){
                        this.makeToast('danger','Error 403',"Please, select user.");
                        this.show = false;
                   }else if(this.properties_selected.length == 0){
                           this.makeToast('danger','Error 403',"Please, select room.");
                           this.show = false;
                   }else{
                       this.input.properties = this.properties_selected;
                       this.input.users = this.users_selected;
                        this.input.created_by = this.userData.id;
                       var data = JSON.stringify(this.input);
                       
                           axios.post('enquiry/v1/add',data)
                            .then(async(res) => { 
                                console.log('res',res);
                                if(!res.data.success){
                                    this.makeToast('danger','Error 403',res.data.message);
                                
                                    this.show = false;
                                }else{
                                    if(this.checkout != undefined){
                                        const resCart = await axios.delete('property/v1/truncate-cart/'+this.userData.id);
                                        if(resCart.data.success){
                                             this.$store.commit('app-p/UPDATE_CART_ITEMS_COUNT',0)

                                        }
                                          this.show = false;
                                        this.$router.push('/enquiry/lists', () => {
                                    this.$toast({
                                        component: ToastificationContent,
                                        position: 'top-right',
                                        props: {
                                        title: `Done`,
                                        icon: 'CoffeeIcon',
                                        variant: 'success',
                                        text: `You have successfully created.`,
                                        },
                                    })
                                });
                                    }else{
                                         this.show = false;
                                         this.$router.push('/enquiry/lists', () => {
                                    this.$toast({
                                        component: ToastificationContent,
                                        position: 'top-right',
                                        props: {
                                        title: `Done`,
                                        icon: 'CoffeeIcon',
                                        variant: 'success',
                                        text: `You have successfully created.`,
                                        },
                                    })
                                });

                                    }
                                    
                                   
                                
                                

                                }
                            // this.actions = res.data.data; 
                            }).catch(error => {
                                this.show = false;
                                this.makeToast('danger','Error 403',error);
                                console.log('error',error);
                            })

                       

                   }

               } else {
                   this.show = false;
               }
          });
      },
    addEmail() {
        const email = this.newEmail.trim()
        if (email && this.validateEmail(email)) {
            this.input.ccEmails.push(email)
            this.newEmail = ''
        } else if (email) {
            alert('Invalid email format')
        }
    },
    removeEmail(index) {
        this.input.ccEmails.splice(index, 1)
    },
    validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return re.test(email)
    },
    getDefaultEmail() {
        axios.get('enquiry/v1/email/getDefault')
            .then(res => {
                const response = res?.data?.data;
                this.defaultEmails = response
                this.input.ccEmails = this.defaultEmails
            })
    },
    openPropertyModal() {
      this.modalSelected = [...this.properties_selected];
      this.showPropertyModal = true;
    },
    openUserModal() {
      this.modalSelectedUsers = [...this.users_selected];
      this.showUserModal = true;
      this.currentPage = 1;
      this.get_users();
    },
    applyUserModalSelection() {
      this.modalSelectedUsers.forEach(item => {
        const exists = this.users_selected.findIndex(p => p.id === item.id);
        if (exists < 0) {
          this.users_selected.push(item);
        }
      });
      const selectedIds = this.modalSelectedUsers.map(i => i.id);
      this.users_selected = this.users_selected.filter(p => selectedIds.includes(p.id));
      this.totalRowsSelected = this.users_selected.length;
      this.modalSelectedUsers = [];
      this.showUserModal = false;
    },
    applyModalSelection() {
      this.modalSelected.forEach(item => {
        const exists = this.properties_selected.findIndex(p => p.id === item.id);
        if (exists < 0) {
          this.properties_selected.push(item);
        }
      });
      const selectedIds = this.modalSelected.map(i => i.id);
      this.properties_selected = this.properties_selected.filter(p => selectedIds.includes(p.id));
      this.totalpsRows = this.properties_selected.length;
      this.modalSelected = [];
      this.showPropertyModal = false;
    },
    resetModalFilters() {
      this.propertyfilter = null;
      this.ownerfilter = null;
      this.building = null;
      this.unit = null;
      this.types = null;
      this.floor = null;
      this.bedroom = null;
      this.sqm_min = null;
      this.sqm_max = null;
      this.sqm_min_display = '';
      this.sqm_max_display = '';
      this.price_rent_min = null;
      this.price_rent_max = null;
      this.price_rent_min_display = '';
      this.price_rent_max_display = '';
      this.price_sale_min = null;
      this.price_sale_max = null;
      this.price_sale_min_display = '';
      this.price_sale_max_display = '';
      this.statusId = '';
      this.modalPlaceKeyword = null;
      this.get_properties();
    },
    onModalSortChanged(ctx) {
      const colMap = { price_rent: 'rent_price', price_sale: 'sale_price' };
      this.modalSortBy = colMap[ctx.sortBy] || ctx.sortBy;
      this.modalSortDesc = ctx.sortDesc;
      this.currentpPage = 1;
      this.get_properties();
    },
    handleNumericInput(rawField, displayField, val) {
      const raw = val.replace(/[^0-9]/g, '');
      this[rawField] = raw ? raw : null;
      this[displayField] = raw ? Number(raw).toLocaleString('en') : '';
    },
  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/pages/ui-feather.scss';

.section-label {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #b9b9c3;
}
.empty-state {
  text-align: center;
  padding: 40px 20px;
}
.property-modal-split {
  display: flex;
  height: 82vh;
  overflow: hidden;
  position: relative;
}
.property-modal-sidebar {
  width: 220px;
  min-width: 220px;
  border-right: 1px solid #ebe9f1;
  overflow-y: auto;
  padding: 1rem;
  background-color: #f8f8f8;
  .filter-field-label {
    font-size: 0.75rem !important;
    color: #6e6b7b !important;
    margin-bottom: 3px !important;
    font-weight: 500 !important;
  }
  .form-group { margin-bottom: 0.75rem; }
}
.property-modal-results {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 0;
}
.mobile-filter-bar {
  border-bottom: 1px solid #ebe9f1;
  background: #fff;
}
.modal-footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .modal-footer-actions { display: flex; gap: 8px; }
}
.mobile-filter-backdrop { display: none; }
@media (max-width: 767px) {
  .property-modal-split { height: 78vh; }
  .property-modal-sidebar {
    position: absolute;
    top: 0; left: 0;
    height: 100%;
    width: 280px; min-width: 280px;
    z-index: 100;
    transform: translateX(-100%);
    transition: transform 0.25s ease;
    &.mobile-open {
      transform: translateX(0);
      box-shadow: 4px 0 16px rgba(0,0,0,0.15);
    }
  }
  .mobile-filter-backdrop {
    display: block;
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,0.4);
    z-index: 99;
  }
}
</style>
